export default __webpack_public_path__ + "static/slide6-4cb05a4beaf6378edca2453198953d77.jpg";